var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { NumericUtils } from '@shared/utils/NumericUtils';
import { TIF } from '@shared/utils/Trading/OrderTif';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { Quantity } from '@shared/commons/UtilsClasses/Quantity';
import { DynProperty } from '../../DynProperty';
import { IsAllowed } from '../../IsAllowed';
import { OrderExecutorUtils } from '../../Trading/OrderExecutorUtils';
import { Resources } from '@shared/localizations/Resources';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
import { SLTPTriggerUtils } from './SLTPTriggerUtils';
import { OrderEditUpdateData } from '@shared/utils/Trading/OrderEditUpdateData';
import { SLTPEdit, SLTPMode } from './SLTPEdit';
import { OrderEditBaseUtils } from '@shared/utils/Trading/OrderEditBaseUtils';
import { OrderEditBase } from './order-edit/OrderEditBase';
import { DataCache } from '../../DataCache';
import { BaseSettings } from '../../Settings/BaseGeneralSettingsWrapper';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { OrderUtils } from '@shared/utils/Trading/OrderUtils';
// TODO. Refactor.
export class PositionEdit extends OrderEditBase {
    constructor(data) {
        super(data);
        this.position = data.position;
        this.sltp = new SLTPEdit(data.dataCache, SLTPMode.Absolute);
        this.slBasePriceGetter = this.slBasePriceGetter.bind(this);
        this.tpBasePriceGetter = this.tpBasePriceGetter.bind(this);
        // TODO. Ugly.
        this.canEditSLOrTrailingStop = true;
        this.canEditTP = true;
        this.mqData = {
            newPrType: null,
            modQT: null,
            maxQT: null,
            enabled: false,
            errVisible: false,
            hasError_bound: false,
            hasError_StartOfDay: false,
            hasError_dp: false
        };
        // TODO. Refactor.
        this.updateParameters(new OrderEditUpdateData(null, {
            instrument: this.position.Instrument,
            account: this.position.Account,
            side: this.position.BuySell,
            position: this.position,
            quantity: new Quantity(this.position.Amount, true),
            tif: new TIF(this.position.TimeInForce, new Date(this.position.ExpireAt)),
            productType: this.position.ProductType,
            placedFrom: data.placedFrom
        }));
        this.setSLTP({ sltpHolder: this.position.createSlTpHolder() });
        DataCache.OnAddSLOrderToPosition.Subscribe(this.updateSLWhenActivate, this); // #93646
        // TMP FLAG TODO REMOVE
        // SKIP NO CHANGE
        this.UseSkipNoChange = false;
    }
    getOrderTypeId() {
        return OrderType.PositionEdit;
    }
    tradingAllowed() {
        return IsAllowed.IsPositionModifyingAllowed(this.position).Allowed;
    }
    // public override getOrderTypeIdValidation (): OrderType {
    //     return OrderType.Market;
    // }
    getParameterNameArray() {
        return [
            OrderEditBaseUtils.PRODUCT_TYPE_AND_MQ,
            OrderEditBaseUtils.ATTENTION_MSG,
            OrderEditBaseUtils.SLTP_PARAM,
            OrderEditBaseUtils.OFFMARKET_ENABLED,
            OrderEditBaseUtils.EST_AVAILABLE_CASH
        ];
    }
    // TODO. Refactor.
    setTradingData(tradingDataDict) {
        const hasPos = tradingDataDict && 'position' in tradingDataDict;
        if (hasPos) {
            this.position = tradingDataDict.position;
        }
        const newTradingDataDict = super.setTradingData(tradingDataDict);
        if (!newTradingDataDict) {
            return newTradingDataDict;
        }
        if (hasPos) {
            newTradingDataDict.position = this.position;
        }
        return newTradingDataDict;
    }
    // TODO. Refactor base class, trading data. Ugly.
    getTradingData() {
        const tradingDataDict = super.getTradingData();
        tradingDataDict.position = this.position;
        return tradingDataDict;
    }
    // TODO. Refactor base class, trading data. Ugly.
    getDataForRequest() {
        const reqData = super.getDataForRequest();
        if (reqData) {
            reqData.position = this.position;
            reqData.canEditSLOrTrailingStop = this.canEditSLOrTrailingStop;
            reqData.canEditTP = this.canEditTP;
            reqData.isSLchanged = this.oldAndNewSLdiffer();
            reqData.isTPchanged = this.oldAndNewTPdiffer();
            reqData.placedFrom = this.placedFrom;
            // TODO REMOVE
            reqData.UseSkipNoChange = this.UseSkipNoChange;
        }
        return reqData;
    }
    IsQuantityModified() {
        return this.mqData.enabled;
    }
    getQuantity() {
        return this.mqData.modQT;
    }
    getNewProductType() {
        return this.mqData.newPrType;
    }
    dispose() {
        DataCache.OnAddSLOrderToPosition.UnSubscribe(this.updateSLWhenActivate, this);
        this.position = null;
        super.dispose();
    }
    updateSLWhenActivate() {
        // #93646
        this.ParametersChanged.Raise({ sltp: this.toDynProperty_sltp() });
    }
    valid() {
        return super.valid() && this.validMQ();
    }
    validMQ() {
        if (this.IsQuantityModified()) {
            return !this.mqData.hasError_bound && !this.mqData.hasError_dp && !this.mqData.hasError_StartOfDay;
        }
        return true;
    }
    update_sltp(updateData) {
        let updated = this.sltp.update(updateData, this.getTradingData());
        if (this.mqData.enabled && (this.sltp.sl.enabled || this.sltp.tp.enabled)) {
            updated = true;
            const dp = this.toDynProperty_ModifyQuantity();
            dp.enabled = false;
            this.updateParameters(new OrderEditUpdateData({ ModifyQuantity: dp }));
            if (this.position.SLOrder !== null || this.position.TPOrder !== null) {
                const dp = this.toDynProperty_attention();
                dp.visible = false;
                this.updateParameters(new OrderEditUpdateData({ attention: dp }));
            }
        }
        return updated;
    }
    update_ModifyQuantity(updateData) {
        let updated = false;
        const dp = updateData.dp;
        if (!(dp === null || dp === void 0 ? void 0 : dp.visible)) {
            return false;
        }
        updated = this.mqData.enabled !== dp.enabled || updated;
        this.mqData.enabled = dp.enabled;
        if (dp.enabled) {
            this.sltp.sl.enabled = false;
            this.sltp.tp.enabled = false;
            if (this.position.SLOrder !== null || this.position.TPOrder !== null) {
                const dp = this.toDynProperty_attention();
                dp.visible = true;
                this.updateParameters(new OrderEditUpdateData({ attention: dp }));
            }
            if (dp.selectedValue) {
                const val = parseInt(dp.selectedValue.value);
                updated = this.mqData.newPrType !== val || updated;
                this.mqData.newPrType = val;
            }
            updated = this.mqData.modQT !== dp.value || updated;
            this.mqData.modQT = dp.value;
            const qty = dp.value;
            const errBound = qty > this.mqData.maxQT;
            const errStartOfDay = this.position.Amount <= this.position.StartOfDayAmount;
            updated = this.mqData.hasError_bound !== errBound || updated;
            this.mqData.hasError_bound = errBound;
            updated = this.mqData.hasError_StartOfDay !== errStartOfDay || updated;
            this.mqData.hasError_StartOfDay = errStartOfDay;
            updated = this.mqData.hasError_dp !== dp.hasError || updated;
            this.mqData.hasError_dp = dp.hasError;
        }
        return !!updated;
    }
    toDynProperty_ModifyQuantity() {
        const dp = new DynProperty();
        dp.type = DynProperty.PRODUCT_TYPE_AND_MQ;
        dp.visible = IsAllowed.IsModifyProductTypeAllowed(this.position).Allowed;
        if (!dp.visible) {
            return dp;
        }
        const instrument = this.instrument;
        const acc = this.position.Account;
        const pT = this.position.ProductType;
        const inLots = BaseSettings.isQuantityInLots;
        const settings = Quantity.getQuantityNumericSettings(instrument, acc, inLots);
        const baseValue = Quantity.convertQuantityValue(new Quantity(this.position.Amount - (this.position.StartOfDayAmount || 0), true), instrument, inLots, acc, pT);
        if (this.mqData.modQT) {
            dp.value = this.mqData.modQT;
        }
        else {
            dp.value = baseValue;
        }
        if (dp.value < 0) {
            dp.value = 0;
        }
        this.mqData.maxQT = baseValue;
        dp.minimalValue = settings.minValue;
        dp.maximalValue = NumericUtils.MAXVALUE;
        dp.decimalPlaces = settings.decimalPrecision;
        dp.increment = settings.step;
        dp.productType = pT;
        const dict = InstrumentUtils.getAllowedProductTypeDict(instrument).filter((pt) => {
            return pt !== dp.productType;
        });
        const items = dict.map(function (productType) {
            return {
                type: NewContextMenuItemType.Default,
                value: productType.toString(),
                text: InstrumentUtils.GetLocalizedProductType(instrument, productType)
            };
        });
        dp.objectVariants = items;
        dp.selectedValue = items[0];
        dp.enabled = this.mqData.enabled;
        dp.hasError = this.mqData.hasError_dp || this.mqData.hasError_StartOfDay;
        dp.customLess = false;
        if (this.mqData.hasError_bound) {
            dp.hasError = this.mqData.hasError_bound;
            dp.customError = Resources.getResource('general.trading.qtyMoreTodayTradedValue');
        }
        if (this.mqData.hasError_StartOfDay) {
            dp.hasError = this.mqData.hasError_StartOfDay;
            dp.customError = Resources.getResource('general.trading.noQuantityAvailable');
            dp.customLess = true;
        }
        dp.localizationKey_type = 'screen.modifyOrder.modifyPosition.TargetProductType';
        dp.localizationKey_qty = 'screen.modifyOrder.modifyPosition.ModifyQuantity';
        return dp;
    }
    toRawValue_ModifyQuantity() {
        const resData = { quantity: null, newPrType: null };
        if (this.mqData.enabled) {
            resData.quantity = this.mqData.modQT;
            resData.newPrType = this.mqData.newPrType;
        }
        return resData;
    }
    update_attention(updateData) {
        let updated = false;
        const dp = updateData.dp;
        if (!dp) {
            return false;
        }
        updated = this.mqData.errVisible !== dp.visible || updated;
        this.mqData.errVisible = dp.visible;
        return updated;
    }
    toDynProperty_attention() {
        const dp = new DynProperty();
        dp.type = DynProperty.ATTENTION_MSG;
        dp.visible = this.mqData.errVisible;
        dp.localizationKey = 'screen.modifyOrder.modifyPosition.ModifyQuantity.SlTpInfo';
        return dp;
    }
    toRawValue_attention() {
        return '';
    }
    validateParameters() {
        const updatedParamNameDict = {};
        if (this.sltp.validate(this.slBasePriceGetter.bind(this), this.tpBasePriceGetter.bind(this), this.getTradingData())) {
            updatedParamNameDict[OrderEditBaseUtils.SLTP_PARAM] = true;
        }
        return updatedParamNameDict;
    }
    // #region SLTP Price Comparers
    getBasePrice() {
        return this.position ? this.position.Price : null;
    }
    sltpBasePriceGetter(isSL) {
        const acc = this.account;
        const pos = this.position;
        const ins = this.instrument;
        const quote = this.quote;
        const isBuy = this.buy();
        return PositionEdit.SlTpPriceGetter(isSL, isBuy, pos, ins, acc, quote);
    }
    slBasePriceGetter() {
        return this.sltpBasePriceGetter(true);
    }
    tpBasePriceGetter(val = false) {
        // todo modify screen must use parametr in future
        // https://tp.traderevolution.com/entity/114272
        return this.sltpBasePriceGetter(val);
    }
    // #endregion SLTP Price Comparers
    // TODO. Ugly.
    setCanEditSLOrTrailingStop(canEdit) {
        this.canEditSLOrTrailingStop = canEdit;
    }
    setCanEditTP(canEdit) {
        this.canEditTP = canEdit;
    }
    getConfirmationText() {
        return __awaiter(this, arguments, void 0, function* (sendMarginRequest = true) {
            const confirmationText = yield this.getConfirmationParams(sendMarginRequest);
            return OrderExecutorUtils.buildPositionEditConfirmationText(this.position, confirmationText);
        });
    }
    getConfirmationParams(sendMarginRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            if (sendMarginRequest)
                yield this.ConfirmationMarginRequest();
            return this.sltp.getConfirmationText(this.getTradingData());
        });
    }
    getOrderConfirmationMarginInfoParameters() {
        const requestData = this.getDataForRequest();
        const oppoiteSide = requestData.side === OperationType.Buy ? OperationType.Sell : OperationType.Buy;
        const position = requestData.position;
        const iSlTpParams = requestData.parameterDict.sltp;
        const sltpHolder = iSlTpParams === null || iSlTpParams === void 0 ? void 0 : iSlTpParams.sltpHolder;
        const slDataReqeust = !isNullOrUndefined(sltpHolder) && !sltpHolder.isSlEmpty() ? this.getDataForRequest() : null;
        const tpDataReqeust = !isNullOrUndefined(sltpHolder) && !sltpHolder.isTpEmpty() ? this.getDataForRequest() : null;
        const confirmationMarginInfoParameters = [];
        if (!isNullOrUndefined(slDataReqeust)) {
            slDataReqeust.side = oppoiteSide;
            if (sltpHolder.isTrailingStop()) {
                slDataReqeust.orderTypeId = OrderType.TrailingStop;
                slDataReqeust.parameterDict.trailingStop = sltpHolder.StopLossPriceValue;
            }
            else if (!sltpHolder.isSllEmpty()) {
                slDataReqeust.orderTypeId = OrderType.StopLimit;
                slDataReqeust.parameterDict.stopPrice = sltpHolder.StopLossPriceValue;
                slDataReqeust.parameterDict.limitPrice = sltpHolder.StopLossLimitPriceValue;
            }
            else {
                slDataReqeust.orderTypeId = OrderType.Stop;
                slDataReqeust.parameterDict.stopPrice = sltpHolder.StopLossPriceValue;
            }
            slDataReqeust.tif = OrderUtils.getDefaultSLTPValidity(position, slDataReqeust.orderTypeId);
            if (!isNullOrUndefined(iSlTpParams.isAllowOTHTradingSL)) {
                slDataReqeust.isAllowOTHTrading = iSlTpParams.isAllowOTHTradingSL;
            }
            else {
                slDataReqeust.isAllowOTHTrading = position.isAllowOTHTradingTP;
            }
            const slMarginInfoParams = slDataReqeust.GetMarginParameters();
            confirmationMarginInfoParameters.push({ isOnlyOffMarket: true, marginInfoParameters: slMarginInfoParams });
        }
        if (!isNullOrUndefined(tpDataReqeust)) {
            tpDataReqeust.side = oppoiteSide;
            tpDataReqeust.tif = OrderUtils.getDefaultSLTPValidity(position, OrderType.Limit);
            tpDataReqeust.orderTypeId = OrderType.Limit;
            tpDataReqeust.parameterDict.limitPrice = sltpHolder.TakeProfitPriceValue;
            if (!isNullOrUndefined(iSlTpParams.isAllowOTHTradingTP)) {
                tpDataReqeust.isAllowOTHTrading = iSlTpParams.isAllowOTHTradingTP;
            }
            else {
                tpDataReqeust.isAllowOTHTrading = position.isAllowOTHTradingTP;
            }
            const tpMarginInfoParams = tpDataReqeust.GetMarginParameters();
            confirmationMarginInfoParameters.push({ isOnlyOffMarket: true, marginInfoParameters: tpMarginInfoParams });
        }
        return confirmationMarginInfoParameters;
    }
    oldAndNewSLdiffer() {
        var _a;
        if (!((_a = this.position) === null || _a === void 0 ? void 0 : _a.SLOrder))
            return true;
        const slOrder = this.position.SLOrder;
        if (this.sltp.trailingStop.enabled ||
            (!this.sltp.trailingStop.enabled && slOrder.OrderType === OrderType.TrailingStop)) {
            if (this.sltp.trailingStop.enabled && slOrder.OrderType === OrderType.TrailingStop) {
                // Need normalize calculation of this.sltp.trailingStop.value. it used not correct values, not enough parameters at PositionSLTPEdit.prototype.update
                const value = this.sltp.trailingStop.visibleValue || this.sltp.trailingStop.value;
                if (this.sltp.trailingStop.visibleValue) {
                    const ins = this.instrument;
                    const newPice = ins.roundPrice(ins.calculatePrice(this.position.OpenPrice, (this.position.BuySell ? 1 : -1) * value));
                    return slOrder.Price != ins.roundPrice(newPice);
                }
                return slOrder.TrStopOffset != value;
            }
            else {
                return true;
            } // slOrder.TrStopOffset != this.sltp.trailingStop.value     // есть tr.stop сравниваем только его
        }
        else if (slOrder.getPriceForStopLoss() == this.sltp.sl.value) {
            if (this.sltp.sl.sllValue !== null) {
                return slOrder.Price != this.sltp.sl.sllValue;
            }
            else {
                return false;
            } // sll нет, slPrice равны
        }
        return true;
    }
    oldAndNewTPdiffer() {
        var _a;
        if (((_a = this.position) === null || _a === void 0 ? void 0 : _a.TPOrder) && this.position.TPOrder.Price == this.sltp.tp.value) {
            return false;
        }
        return true;
    }
    isPosition() {
        return true;
    }
    static SlTpPriceGetter(isSL, isBuy, position, instrument, account, quote) {
        let result = 0;
        let askOrBid = /* isSL ? */ isBuy ? 'BidSpread_SP_Ins' : 'AskSpread_SP_Ins'; // :
        // (isBuy ? 'AskSpread_SP_Ins' : 'BidSpread_SP_Ins')  // согласно последнему комменту аналитика в https://tp.traderevolution.com/entity/101728
        const short = SLTPTriggerUtils.GetShortByOrder(position);
        const bySLTPtrigger = SLTPEdit.GetStrByShort(short, isSL, isBuy); // picking trigger price #109798 docs(3.3.2) Trading logic)
        if (bySLTPtrigger) {
            askOrBid = bySLTPtrigger + 'Spread_SP_Ins';
        }
        if (quote) {
            result = quote[askOrBid](DataCache.GetSpreadPlan(account), instrument);
        }
        return result;
    }
}
